import { render, staticRenderFns } from "./cModaldestino.vue?vue&type=template&id=72c4a2a5"
import script from "./cModaldestino.vue?vue&type=script&lang=js"
export * from "./cModaldestino.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports